(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/oddset/common/assets/javascripts/flag-mapping.js') >= 0) return;  svs.modules.push('/components/oddset/common/assets/javascripts/flag-mapping.js');
"use strict";


const FlagMap = {
  mexiko: 'mex',
  sydafrika: 'zaf',
  sydkorea: 'kor',
  tjeckien: 'cze',
  kanada: 'can',
  'bosnien-hercegovina': 'bih',
  usa: 'usa',
  qatar: 'qat',
  brasilien: 'bra',
  marocko: 'mar',
  haiti: 'hti',
  skottland: 'sco',
  australien: 'aus',
  turkiet: 'tur',
  tyskland: 'deu',
  curacao: 'cuw',
  nederländerna: 'nld',
  japan: 'jpn',
  elfenbenskusten: 'civ',
  ecuador: 'ecu',
  sverige: 'swe',
  tunisien: 'tun',
  spanien: 'esp',
  'kap verdeöarna': 'cpv',
  belgien: 'bel',
  egypten: 'egy',
  saudiarabien: 'sau',
  uruguay: 'ury',
  iran: 'irn',
  'nya zeeland': 'nzl',
  österrike: 'aut',
  jordanien: 'jor',
  frankrike: 'fra',
  senegal: 'sen',
  irak: 'irq',
  norge: 'nor',
  argentina: 'arg',
  algeriet: 'dza',
  portugal: 'prt',
  'dr kongo': 'cod',
  england: 'eng',
  kroatien: 'hrv',
  ghana: 'gha',
  panama: 'pan',
  uzbekistan: 'uzb',
  colombia: 'col',
  paraguay: 'pry',
  schweiz: 'che'
};
const toExport = {
  FlagMap
};
if (svs.isServer) {
  module.exports = toExport;
} else {
  setGlobal('svs.components.oddset.common.flagMapping', toExport);
}

 })(window);